import React from 'react';
import { FormattedMessage } from 'react-intl';
import cn from 'classnames';

import { ExtendedRouts } from 'app-constants';
import { CategorizerHeadingRow, FavoriteIcon, SmartLink } from 'components';
import { useWithLocation } from 'hooks';
import globalMessages from 'messages';
import favorite from 'modules/favorite';
import { isFavoritePage } from 'utils';

import './categorizerHeadingFavorite.scss';

const { FavoriteCountAll } = favorite.components;

const CategorizerHeadingFavorite: React.FC = () => {
    const isActive = useWithLocation(isFavoritePage);

    return (
        <div
            styleName={cn('container ', {
                'is-active': isActive,
            })}
        >
            <SmartLink to={ExtendedRouts.FAVORITE_UPCOMING}>
                <CategorizerHeadingRow
                    isActive={isActive}
                    prefix={<FavoriteIcon isActive={isActive} />}
                    suffix={<FavoriteCountAll />}
                >
                    <FormattedMessage {...globalMessages.favorites} />
                </CategorizerHeadingRow>
            </SmartLink>
        </div>
    );
};

export default React.memo(CategorizerHeadingFavorite);
